import i18n from "@/i18n";

export const selectUsersFields = [
    {
        key: "name",
        label: i18n.t("common.name"),
        tdClass: "text-left",
        sortable: true,
        sortDirection: "desc"
    }
];
